module.exports = __webpack_public_path__ + "account/img/266.0bfbce49.png";